import { ProjectItemType } from '../project/project-item-type.enum';
import { ProjectSectionUnitProgress } from '../project/project-section-unit-progress.model';
import { JgPhysicalInspUnitItemInfo } from './jg-physical-insp-unit-item-info.model';
export class JgPhysicalInspUnit extends ProjectSectionUnitProgress {
  jgSectionId?: number;
  dwTypeName?: string;
  dwTypeNameSort?: number;
  dwCodeSort?: number;
  jgFbName?: string;
  jgFbWeight?: number;
  jgFbNameSort?: number;
  jgFxName?: string;
  jgFxProjectTypeCode?: string;
  jgFxProjectTypeName?: string;
  type?: ProjectItemType;
  jgPhysicalInspUnitItems?: Array<JgPhysicalInspUnitItemInfo>;
  // 前端自用
  checkAll?: boolean;
  checkAllDisabled?: boolean;
  asPrevDisabled?: boolean;

  static filterRecordsByMile(
    source: JgPhysicalInspUnit[],
    start: string,
    end: string,
  ): JgPhysicalInspUnit[] {
    const copy: JgPhysicalInspUnit[] = JSON.parse(JSON.stringify(source));
    // 里程标准化
    //
    // （一）标准化为以米为单位的整数（有可能为负数），并记录部位；
    // （二）单端里程正则表达式：[-] [C] (K|k) m + n，对应标准化里程的计算公式为
    //            【类型=里程，部位=大写[C], 数字化里程 = [-] （m×1000+n）】
    // （1）[-]：负号，表示该里程为负数；无则表示为正数
    // （2）[C]：除K和k之外任意若干字母，在K之前，表示里程所在分部工程部位，如ZDK，表示Z匝道地面里程，记录位置为ZD；无则表示：
    //       （2.1）主线单位工程的里程
    //       （2.2）单位工程内里程无需携带分部信息
    // （3）(K|k)：大写K或小写K，为里程标志，  则记录：类型=里程
    // （4）m：表示公里数，位数≥1位
    // （5）n：表示米数，位数=3
    // （三）起止里程间隔符：～(中文)、~（西文）、—（中文）
    // （四）起止里程根据上述解析方式，表示为[C][S,E]
    // （1）确保 E≥S
    // （2）否则 S和E的数值对换
    // （3）两端的部位必须相同
    // （五）举例：
    // （1）k0+010～K1+200：【类型=里程, 部位=，起止里程=[10，1200] 】
    // （2）-gk0+150 ~ -GK1+096：【类型=里程, 部位=G，起止里程=[-1096,-150]】
    // 注：解析过程去掉所有中英文空格
    // 桩号标准化
    // （一）标准化为整数（≥0），并记录部位；
    // （二）单端桩号正则表达式：[C]m[-n][#]，对应标准化桩号的计算公式为
    //            【类型=桩号， 部位=大写[C] ，数字化桩号 = m×1000[+n] 】
    // （1）[C]：任意若干字母，在n之前，表示桩号所在分部工程部位，如SP6#，表示南桥6号辅助墩，记录位置为大写SP；无则表示：
    //       （2.1）主线单位工程的桩号
    //       （2.2）单位工程内桩号无需携带分部信息
    // （2）m：表示主桩号数字，位数不限
    // （3）[-n]：表示子桩号数字，位数不限（一般为1～2位）
    // （4）[#]：桩号符号，可以没有
    // （三）起止桩号间隔符：～(中文)、~（西文）、-（英文），—（中文）
    // （四）起止桩号根据上述解析方式，表示为[C][S,E]
    // （1）确保 E≥S
    // （2）否则 S和E的数值对换
    // （3）两端的部位必须相同
    // （4）若某个部位只有一端桩号，则也表示为[C][S,E] （S=E）
    // （5）举例：
    // （1）256#墩：【类型=桩号, 部位=，起止桩号=[256000, 256000] 】
    // （2）NL01#承台：【类型=桩号, 部位=NL，起止桩号=[1000,1000]】
    // （3）N2#-8桩基： 【类型=桩号, 部位=N，起止桩号=[2008,2008]】
    // （4）NP4-NP3墩：【类型=桩号, 部位=NP，起止桩号=[3000,4000] 】
    // （5）SP4-1-SP4-6桩基：【类型=桩号, 部位=SP，起止桩号=[4001,4006]】
    // 注：解析过程去掉所有中英文空格
    // 匹配规则
    // （一）若：WBS分部工程单元里程桩号标准化表示为：【类型=T1，部位=C1，起止=[S1,E1]】
    // （二）若：查询条件里程桩号标准化为：【类型=T2，部位=C2，起止=[S2,E2]】
    // （三）比较步骤：
    // （1）比较类型：
    //       （1.1）T1 = T2：继续比较
    //       （1.2）T1 ≠ T2：停止比较，返回“不匹配”
    // （2）比较部位：
    //       （2.1）C1 = C2：继续比较 （注：两者皆为空，表示相同）
    //       （2.2）C1 ≠ C2：停止比较，返回“不匹配”
    // （3）比较起止：
    //       （3.1）E1<S2：停止比较，返回“不匹配”
    //       （3.2）E2<S1：停止比较，返回“不匹配”
    //       （3.3）否则：返回匹配成功（肯定有交集）

    const startTrim = (start ?? '').trim();
    const endTrim = (end ?? '').trim();
    // 起止都为空：不过滤，原样返回
    if (!startTrim && !endTrim) {
      return copy;
    }

    // 解析查询条件：start / end 都作为单端值解析
    const qs = startTrim ? JgPhysicalInspUnit.parseMileOrPile(startTrim) : null;
    const qe = endTrim ? JgPhysicalInspUnit.parseMileOrPile(endTrim) : null;
    let query: NormalizedRange | null = null;
    if (qs && qe) {
      // 两端类型 / 部位必须一致，否则视为无效查询，返回空
      if (qs.type !== qe.type || qs.part !== qe.part) {
        return [];
      }
      const s = Math.min(qs.start, qe.start);
      const e = Math.max(qs.end, qe.end);
      query = { type: qs.type, part: qs.part, start: s, end: e };
    } else if (qs) {
      query = qs;
    } else if (qe) {
      query = qe;
    } else {
      // 用户填了但都解析不出来 → 无法过滤，返回空
      return [];
    }

    return copy.filter((rec) => {
      const parsed = JgPhysicalInspUnit.parseMileOrPile(rec.name ?? '');
      if (!parsed) {
        return false;
      }
      // 类型必须相同
      if (parsed.type !== query!.type) {
        return false;
      }
      // 部位必须相同（两者皆空也算相同）
      if (parsed.part !== query!.part) {
        return false;
      }
      // 区间有交集：!(E1<S2 || E2<S1)
      if (parsed.end < query!.start) {
        return false;
      }
      if (query!.end < parsed.start) {
        return false;
      }
      return true;
    });
  }

  /**
   * 解析里程或桩号字符串。优先按里程（含 K/k）解析，失败再按桩号解析。
   */
  private static parseMileOrPile(raw: string): NormalizedRange | null {
    const s = JgPhysicalInspUnit.stripSpaces(raw);
    if (!s) {
      return null;
    }
    return JgPhysicalInspUnit.parseMile(s) ?? JgPhysicalInspUnit.parsePile(s);
  }

  /** 去掉所有中英文空格 */
  private static stripSpaces(s: string): string {
    return (s ?? '').replace(/[\s\u3000]/g, '');
  }

  /** 解析单端里程：[-][C](K|k)m+nnn，n 必须 3 位 */
  private static parseMileToken(
    s: string,
  ): { part: string; value: number } | null {
    const m = /^(-)?([A-Za-z]*)([Kk])(\d+)\+(\d{3})$/.exec(s);
    if (!m) {
      return null;
    }
    const letters = m[2] ?? '';
    // [C] 不可包含 K/k
    if (/[Kk]/.test(letters)) {
      return null;
    }
    const sign = m[1] === '-' ? -1 : 1;
    const km = parseInt(m[4], 10);
    const meters = parseInt(m[5], 10);
    return { part: letters.toUpperCase(), value: sign * (km * 1000 + meters) };
  }

  /** 解析里程：单端或起止区间。区间分隔符：～(中文)、~(西文)、—(中文) */
  private static parseMile(s: string): NormalizedRange | null {
    const sepIdx = s.search(/[~～—]/);
    if (sepIdx >= 0) {
      const a = JgPhysicalInspUnit.parseMileToken(s.substring(0, sepIdx));
      const b = JgPhysicalInspUnit.parseMileToken(s.substring(sepIdx + 1));
      if (!a || !b || a.part !== b.part) {
        return null;
      }
      const start = Math.min(a.value, b.value);
      const end = Math.max(a.value, b.value);
      return { type: 'mile', part: a.part, start, end };
    }
    const one = JgPhysicalInspUnit.parseMileToken(s);
    if (!one) {
      return null;
    }
    return { type: 'mile', part: one.part, start: one.value, end: one.value };
  }

  /**
   * 从字符串开头解析一个桩号 token：[C]m[#][-n][#]（# 可在 -n 前或后，均可选）。
   * 返回该 token 表示的区间 [start, end]：
   *   - 有子桩号 -n：精确点 [m*1000+n, m*1000+n]
   *   - 无子桩号：整段主桩号块 [m*1000, m*1000+999]
   * （这样 144#～146# 能覆盖到 146-1#、146-2# 等子桩号）
   * consumed 为消耗掉的字符长度（剩余视为后缀）。
   */
  private static parsePileToken(s: string): {
    part: string;
    start: number;
    end: number;
    consumed: number;
  } | null {
    const m = /^([A-Za-z]*)(\d+)/.exec(s);
    if (!m) {
      return null;
    }
    const part = (m[1] ?? '').toUpperCase();
    const main = parseInt(m[2], 10);
    let consumed = m[0].length;
    let hasSub = false;
    let sub = 0;
    // 允许 # 出现在 -n 之前
    if (s[consumed] === '#') {
      consumed++;
    }
    // 子桩号 -n（n 必须为数字）
    if (s[consumed] === '-') {
      const rest = s.substring(consumed + 1);
      const sm = /^(\d+)/.exec(rest);
      if (sm) {
        hasSub = true;
        sub = parseInt(sm[1], 10);
        consumed += 1 + sm[0].length;
        // 允许 # 出现在 -n 之后
        if (s[consumed] === '#') {
          consumed++;
        }
      }
    }
    const base = main * 1000;
    if (hasSub) {
      return { part, start: base + sub, end: base + sub, consumed };
    }
    return { part, start: base, end: base + 999, consumed };
  }

  /**
   * 解析桩号：单端或起止区间。
   * 显式分隔符：～(中文)、~(西文)、—(中文)；
   * 英文 `-` 兼具子桩号与区间分隔符两种语义：仅当其后紧跟字母时才视为区间分隔符。
   */
  private static parsePile(s: string): NormalizedRange | null {
    // 优先按显式分隔符切分
    const explicitIdx = s.search(/[~～—]/);
    if (explicitIdx >= 0) {
      const left = s.substring(0, explicitIdx);
      const right = s.substring(explicitIdx + 1);
      const a = JgPhysicalInspUnit.parsePileToken(left);
      const b = JgPhysicalInspUnit.parsePileToken(right);
      if (!a || !b || a.part !== b.part) {
        return null;
      }
      return {
        type: 'pile',
        part: a.part,
        start: Math.min(a.start, b.start),
        end: Math.max(a.end, b.end),
      };
    }
    const first = JgPhysicalInspUnit.parsePileToken(s);
    if (!first) {
      return null;
    }
    // 看 token 之后是否为 `-字母...`（英文短横作为区间分隔符）
    const tail = s.substring(first.consumed);
    if (tail.startsWith('-') && /^[A-Za-z]/.test(tail.substring(1))) {
      const second = JgPhysicalInspUnit.parsePileToken(tail.substring(1));
      if (second && second.part === first.part) {
        return {
          type: 'pile',
          part: first.part,
          start: Math.min(first.start, second.start),
          end: Math.max(first.end, second.end),
        };
      }
    }
    // 单端
    return {
      type: 'pile',
      part: first.part,
      start: first.start,
      end: first.end,
    };
  }
}

/** 标准化后的里程/桩号区间 */
interface NormalizedRange {
  type: 'mile' | 'pile';
  part: string;
  start: number;
  end: number;
}
